import Layout from '../components/Layout';
import './VironNotice.css';
import SaveClubImg from '../assets/SaveClub.png';
import SaveEveryYearImg from '../assets/SaveEveryYear.png';
import join from '../assets/join.png';

function SaveClub() {

    return (
        <Layout>
            <div className='container'>
                <div className="row">
                    <div className='col'>
                        <div className='mt-20'>
                            <h2 className='text-light-blue text-center'>Coming Soon… </h2>
                            {/* https://viron.network/member */}
                            <div style={{ display: "flex", justifyContent: "center" }}><img className='mt-10' src={SaveClubImg} alt="SaveClub" width="200px" /></div>
                            <hr className='mb-10 mt-20' />
                            <p>After you are set up with your daily income position by TXC, you will soon be able to activate your own SAVE CLUB account! </p>
                            <p><b>In other words, “make money” with TEXITcoin (TXC)… </b> <b className='text-light-blue'>“save money” with SAVE CLUB
                                (SC)! </b> </p>
                            <p className='text-left text-light-blue' style={{ marginLeft: "60px", fontWeight: "500" }}>*Of course, with SAVE CLUB’s business center, you can also make additional
                                income with its forced matrix compensation plan!</p>
                            <hr className='mb-10 mt-20' />
                            <div>
                                <p>With our strategic corporate cooperation with SAVE CLUB’s CEO: Mr. Charles Mui…<br />
                                    *Soon, you will be able to click on the<b>“<a href='https://www.saveclub.com/vnetwork' style={{ cursor: 'pointer', color: "#467885" }}>Activate: SAVE CLUB (SC)</a>”</b> button (in your VIRON
                                    back office) to have your SC account created securely and automatically! </p>
                            </div>
                            <ul className='main-ul'>
                                <li className='mb-0'>
                                    <li className='mb-0'><b>Your SC account will match your VIRON NETWORK account profile.</b></li>
                                    <ul className='inner-list mt-0'>
                                        <li className='mb-0'>*Note: if your Username is already taken at SC, your Username will have a
                                            “9” added to the end. <b><i>*Later, you can request SC to change your Username if you
                                                wish.</i></b></li>
                                    </ul>
                                </li>
                            </ul>
                            <hr className='mb-10 mt-20' />
                            {/* src="https://viron.network/member/assets/SaveEveryYear.png" */}
                            <div style={{ display: "flex", justifyContent: "center" }}><img className='mt-20' src={SaveEveryYearImg} alt="SaveClub" width="800px" /></div>
                            <hr className='mb-10 mt-20' />
                            <p><i>
                                Imagine going to the store you were planning to visit anyway, using your credit or debit card
                                as you normally would, buying whatever you want, and receiving an immediate deep
                                discount on the spot! No waiting, no scanning receipts (although you can do that later to get
                                the extra savings boost).
                                <span style={{ fontWeight: "bold" }}>
                                    Just savings on the items and brands you would purchase
                                    anyway, based on your
                                    everyday usage and spending habits!</span></i>
                            </p>

                            <p style={{ fontWeight: "bold" }}>
                                Here is what's even more exciting… the SAVINGS alone can quickly surpass your
                                entire VIRON Home-Business (VHB) costs!
                                <span style={{ color: "#ff0000" }}> Now that’s leverage!</span>
                            </p>
                            <hr className='mb-10 mt-20' />
                            <div style={{ display: "flex", justifyContent: "center" }}><img className='mt-20' src={join} alt="SaveClub" width="800px" /></div>
                            <hr className='mb-10 mt-20' />

                            <div>
                                <div className='text-center mb-20'>Additional information by VIRON…</div>
                                <div className="sc-title">Third-Party MLM Company</div>
                                <div className="sc-subtitle">Why SAVE CLUB (“SC”) is Qualified</div>
                                <div className="sc-date">Article Updated: 17 June 2025</div>

                                <p className="sc-paragraph">
                                    <span className="sc-highlight">SC HISTORY & INFORMATION.</span><br /><br />
                                    SC is a solid new MLM company that has been vetted by our Upline Team,
                                    headed by our friend,
                                    Mr. Bruce Nelkin. Bruce has over 30 years of
                                    networking experience and chose SC among at
                                    least three other programs
                                    (at the time of his selection) before joining SC.
                                </p>

                                <p className="sc-paragraph">
                                    *AWARENESS: if you join any MLM
                                    company and you do not have VIRON working for you, it
                                    may have some relevance on <i>“when”</i> you join, or you try to <i>“be as close to the top as
                                        possible”</i> in
                                    that company. However, with VIRON, it does not matter.
                                </p>

                                <p className="sc-paragraph" style={{ marginLeft: "40px" }}>
                                    Because when you engage with VIRON, our systems trigger, and our skilled
                                    sales teams
                                    are assigned to your account and downline. You will grow
                                    <span className="sc-highlight">
                                        <i>{" "} (perhaps even better than if
                                            you were at the top of SC yourself)</i>
                                    </span>{" "}
                                    because your business will be built systematically by{" "}
                                    <span className='underline-text'>professionals</span>.{" "}
                                    <span className="sc-highlight underline-text">
                                        <i>FOR</i>
                                    </span>{" "}
                                    YOU AND FOR EVERYONE PLACED UNDER YOU!
                                </p>

                                <p className="sc-paragraph">
                                    <span className='sc-blue-bold'>With SC, you’ll love the money savings.</span>
                                    <span className="sc-paragraph">
                                        {" "}Essentially, the SC membership costs $299.97 per
                                        year.{" "}
                                        <span className="sc-blue underline-text">
                                            Throughout the year, you’ll be able to save a lot more than that
                                            on your everyday usage
                                            and spending habits.
                                        </span>
                                    </span>
                                </p>
                                <div className="last-section">

                                    <div className="last-dots">::: ::: :::</div>
                                    <div className="last-title">Last but not least…</div>

                                    <hr className="last-hr" />

                                    <p className="last-text">
                                        *YES! Soon, you can purchase{" "}
                                        <span className="last-red">DIRECT REFERRALS (DRs) by VIRON</span>{" "}
                                        to <span className="underline-text">specifically</span>{" "} grow
                                        your SAVE CLUB business as well!{" "}
                                        <span className="last-note">
                                            *DRs by VIRON are always subject to availability. You will be notified
                                            when DRs to power your SC business become available.</span>
                                    </p>

                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </Layout >
    );
}

export default SaveClub;
